export default __webpack_public_path__ + "images/paragraph-bullets.371da62783b482abdce5d6517d919663.svg";